import { Auth } from 'aws-amplify'
import React, { FC, useEffect, useState } from 'react'

type CognitoUser = {
  sub: string
  email: string
  role: string
  idToken: string
}

type ContextType = {
  authenticating: boolean
  isAuthenticated: boolean
  setAuthenticated: (auth: boolean) => void
  setUser: (user: CognitoUser) => void
  getUser: () => CognitoUser
}

const DEFAULT_STATE = {
  authenticating: true,
  isAuthenticated: false,
  user: { sub: '', email: '', role: '', idToken: '' },
  setAuthenticated: () => false,
  setUser: () => null,
  getUser: () => ({ sub: '', email: '', role: '', idToken: '' })
}

export const AuthenticationContext = React.createContext<ContextType>(DEFAULT_STATE)

const Provider: FC = ({ children }) => {
  const [authenticating, setAuthenticating] = useState(DEFAULT_STATE.authenticating)
  const [isAuthenticated, setIsAuthenticated] = useState(DEFAULT_STATE.isAuthenticated)

  const setAuthenticated = (auth: boolean) => {
    setIsAuthenticated(auth)
  }

  const getUser = (): CognitoUser => JSON.parse(window.localStorage.getItem('user') || '{}')
  const setUser = (user: CognitoUser) => window.localStorage.setItem('user', JSON.stringify(user))

  useEffect(() => {
    async function checkAuthStatus() {
      setAuthenticating(true)
      try {
        const authed = await Auth.currentAuthenticatedUser()
        if (authed) {
          setIsAuthenticated(true)
          setAuthenticating(false)
        }
      } catch (error) {
        setIsAuthenticated(false)
        setAuthenticating(false)
      }
    }
    checkAuthStatus()
  }, [isAuthenticated])

  return (
    <AuthenticationContext.Provider
      value={{ authenticating, isAuthenticated, setAuthenticated, getUser, setUser }}
    >
      {children}
    </AuthenticationContext.Provider>
  )
}

export default Provider
